import { render, staticRenderFns } from "./ArticleBrowser.vue?vue&type=template&id=33d0fbf4"
import script from "./ArticleBrowser.vue?vue&type=script&lang=js"
export * from "./ArticleBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports